import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

import SearchInventoryBar from "../../components/generics/SearchInventoryBar";
import Spinner from "../../components/generics/Spinner";
import { fetchCurrentUser, fetchCurrentUserSuccess, fetchCurrentUserFailure } from "../../store/auth/actions";
import {
  SHIPMENTREPORT,
  OFFERLIST,
  CAN_USE_VENDOR_OFFERS,
  CAN_LIST_R365_REPORTS,
  checkAnyPermissions,
  hasPermission,
} from "../../utils/permissons";

import { withRouter } from "../../utils/WithRouter";

export class Sidebar extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: this.props.location.pathname.match("^/reports") ? true : false,
      dropdownInvoice:
        this.props.location.pathname.match("^/invoice") ||
        this.props.location.pathname.match("^/credit_note") ||
        this.props.location.pathname.match("^/purchase_orders") ||
        this.props.location.pathname.match("^/pending_inventory")
          ? true
          : false,
      dropdownShipping: this.props.location.pathname.match("^/shipping") || this.props.location.pathname.match("^/return") ? true : false,
      dropdownOrders: this.props.location.pathname.match("^/orders") ? true : false,
      dropdownMarketInventory: this.props.location.pathname.match("^/market-inventory") ? true : false,
      dropdownMaintenance: this.props.location.pathname.match("^/maintenance") ? true : false,
    };
  }

  componentDidMount() {
    this.props.fetchCurrentUser();
  }
  // ---------------------------------------------------------------------------
  // Dropdowns
  // ---------------------------------------------------------------------------
  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
      dropdownInvoice: false,
      dropdownShipping: false,
      dropdownOrders: false,
      dropdownMarketInventory: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownInvoice = () => {
    this.setState((prevState) => ({
      dropdownInvoice: !prevState.dropdownInvoice,
      dropdownOpen: false,
      dropdownShipping: false,
      dropdownOrders: false,
      dropdownMarketInventory: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownShipping = () => {
    this.setState((prevState) => ({
      dropdownShipping: !prevState.dropdownShipping,
      dropdownOpen: false,
      dropdownInvoice: false,
      dropdownOrders: false,
      dropdownMarketInventory: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownOrders = () => {
    this.setState((prevState) => ({
      dropdownOrders: !prevState.dropdownOrders,
      dropdownShipping: false,
      dropdownOpen: false,
      dropdownInvoice: false,
      dropdownMarketInventory: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownMarketInventory = () => {
    this.setState((prevState) => ({
      dropdownMarketInventory: !prevState.dropdownMarketInventory,
      dropdownOpen: false,
      dropdownInvoice: false,
      dropdownShipping: false,
      dropdownOrders: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownMaintenance = () => {
    this.setState((prevState) => ({
      dropdownMaintenance: !prevState.dropdownMaintenance,
      dropdownOpen: false,
      dropdownInvoice: false,
      dropdownShipping: false,
      dropdownOrders: false,
      dropdownMarketInventory: false,
    }));
  };

  sidebarToggle = (e) => {
    document.body.classList.toggle("sidebar-mobile-show");
  };

  // ---------------------------------------------------------------------------
  // Search
  // ---------------------------------------------------------------------------
  goToInventory = (id) => {
    this.props.history.push(`/inventory/${id}`);
    if (this.props.match.path === "/inventory/:id") {
      this.props.history.go();
    }
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    const { user, loading } = this.props.currentUser;
    if (!user || loading) {
      return <Spinner />;
    } else {
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              {user.is_plant_user && (
                <li className="nav-item">
                  {/* Inventory Search */}
                  <SearchInventoryBar goToInventory={this.goToInventory} />
                </li>
              )}

              {/* Orders */}
              <li className={`nav-item nav-dropdown ${this.state.dropdownOrders ? "open" : ""}`}>
                <span className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownOrders}>
                  <i className="fa fa-list-alt"></i>Orders
                </span>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                    <NavLink to={"/orders"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                      <i className="fa fa-file-text-o"></i>Order List
                    </NavLink>
                  </li>
                </ul>
              </li>

              {/* Market Inventory - visible to all users for testing */}
              {user && (
                <li className={`nav-item nav-dropdown ${this.state.dropdownMarketInventory ? "open" : ""}`}>
                  <span className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownMarketInventory}>
                    <i className="fa fa-barcode"></i>Market Inventory
                  </span>
                  <ul className="nav-dropdown-items">
                    <li className="nav-item">
                      <NavLink to={"/market-inventory/scanner"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-qrcode"></i>Scanner
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/market-inventory/stock-levels"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-cubes"></i>Stock Levels
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/market-inventory/alerts"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-exclamation-triangle"></i>Alerts
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/market-inventory/consumption"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-line-chart"></i>Consumption History
                      </NavLink>
                    </li>
                  </ul>
                </li>
              )}

              {/* Maintenance - visible to plant users and superusers */}
              {(user.is_plant_user || user.is_superuser) && (
                <li className={`nav-item nav-dropdown ${this.state.dropdownMaintenance ? "open" : ""}`}>
                  <span className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownMaintenance}>
                    <i className="fa fa-wrench"></i>Maintenance
                  </span>
                  <ul className="nav-dropdown-items">
                    <li className="nav-item">
                      <NavLink to={"/maintenance"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-dashboard"></i>Dashboard
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/tasks"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-calendar-check-o"></i>Today's Tasks
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/machines"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-cogs"></i>Machines
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/facilities"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-building"></i>Facilities
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/task-templates"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-clipboard"></i>Task Templates
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/task-assignments"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-link"></i>Task Assignments
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/records"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-list"></i>Records
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/settings"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                        <i className="fa fa-cog"></i>Settings
                      </NavLink>
                    </li>
                  </ul>
                </li>
              )}

              {((user.is_market_user && hasPermission(OFFERLIST, CAN_USE_VENDOR_OFFERS)) || user.is_plant_user) && (
                <div>
                  {/* Receiving */}
                  <li className={`nav-item nav-dropdown ${this.state.dropdownInvoice ? "open" : ""}`}>
                    <span className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownInvoice}>
                      <i className="fa fa-list-alt"></i>Receiving
                    </span>
                    <ul className="nav-dropdown-items">
                      {user.is_plant_user && (
                        <div>
                          <li className="nav-item">
                            <NavLink to={"/invoice"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                              <i className="fa fa-file-text-o"></i>Invoices
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink to={"/credit_note"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                              <i className="fa fa-arrow-circle-right"></i>Credit Notes
                            </NavLink>
                          </li>
                        </div>
                      )}

                      <li className="nav-item">
                        <NavLink to={"/purchase_orders"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-archive"></i>Purchase Orders
                        </NavLink>
                      </li>
                      {user.is_plant_user && (
                        <div>
                          <li className="nav-item">
                            <NavLink to={"/pending_inventory"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                              <i className="fa fa-tasks"></i>Pending Inventory
                            </NavLink>
                          </li>
                          {hasPermission(OFFERLIST, CAN_USE_VENDOR_OFFERS) && (
                            <li className="nav-item">
                              <NavLink to={"/price_lists"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                                <i className="fa fa-wpforms"></i>Price Lists
                              </NavLink>
                            </li>
                          )}
                        </div>
                      )}
                    </ul>
                  </li>
                </div>
              )}

              {user.is_plant_user && (
                <div>
                  {/* Production */}
                  <li className="nav-item">
                    <NavLink to={"/session"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                      <i className="fa fa-industry"></i>Production
                    </NavLink>
                  </li>

                  {/* Shipping */}
                  <li className={`nav-item nav-dropdown ${this.state.dropdownShipping ? "open" : ""}`}>
                    <span className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownShipping}>
                      <i className="fa fa-truck"></i>Shipping
                    </span>
                    <ul className="nav-dropdown-items">
                      <li className="nav-item">
                        <NavLink to={"/shipment"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-file-text-o"></i>Shippings
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to={"/return"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-arrow-circle-left"></i>Returns
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  {/* Inventory Audit */}
                  <li className="nav-item">
                    <NavLink to={"/inventory/audit"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                      <i className="fa fa-list-ol"></i>Inventory Audit
                    </NavLink>
                  </li>

                  {/* Locations */}
                  <li className="nav-item">
                    <NavLink to={"/inventory/locations"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                      <i className="fa fa-thumb-tack"></i>Locations
                    </NavLink>
                  </li>
                </div>
              )}

              {/* Reports */}
              {(user.is_superuser || checkAnyPermissions([{ model: SHIPMENTREPORT, perms: [CAN_LIST_R365_REPORTS] }])) && (
                <li className={`nav-item nav-dropdown ${this.state.dropdownOpen ? "open" : ""}`}>
                  <span className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdown}>
                    <i className="fa fa-list-alt"></i>Reports
                  </span>
                  <ul className="nav-dropdown-items">
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink
                          to={"/reports/expired_inventories"}
                          className="nav-link"
                          onClick={this.sidebarToggle}
                          activeClassName="active"
                        >
                          <i className="fa fa-calendar-times-o"></i>Expiration Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/inventory"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="icon-tag"></i>Inventory Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/invoices"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="icon-docs"></i>Invoices Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/inventory_items"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="icon-check"></i>Items on inventory
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/production"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-line-chart"></i>Production Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/shipment"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="icon-graph"></i>Shipments Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/waste"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-trash"></i>Waste Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/yield"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-align-left"></i>Yield Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/ingredients"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-balance-scale"></i>Ingredients Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/receiving"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-level-down"></i>Receiving Report
                        </NavLink>
                      </li>
                    )}
                    {(user.is_superuser || hasPermission(SHIPMENTREPORT, CAN_LIST_R365_REPORTS)) && (
                      <li className="nav-item">
                        <NavLink to={"/reports/R365"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-plug"></i>R365
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/weighted_price"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-book"></i>Weighted Price
                        </NavLink>
                      </li>
                    )} 
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/recall?page=1"} className="nav-link" onClick={this.sidebarToggle} activeClassName="active">
                          <i className="fa fa-bullhorn"></i>Recall Report
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
              )}
            </ul>
          </nav>
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.auth.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCurrentUser: () => {
      dispatch(fetchCurrentUser()).payload.then(
        (response) => {
          dispatch(fetchCurrentUserSuccess(response.data));
        },
        (error) => {
          dispatch(fetchCurrentUserFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));
